import { Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar, Questions } from 'components';
import { useRiskq } from 'hooks/useRiskq';

export function Suitability() {
	const { group, page, title, t, ...ctx } = useRiskq('suitability');
	return (
		<ProgressBar page={page}>
			<Typography className="mb-5" TagName="h3">
				{title}
			</Typography>
			<Questions group={group} />
			<Footer {...ctx} />
		</ProgressBar>
	);
}
